import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import UpSellCarousel from ".";
import { MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL } from "./constants";
import { getItemCount } from "../../state/modules/search";

const withUpSellCarousel = (WrappedComponent) => {
  const WithUpSellCarousel = ({
    itemCount: propItemCount,
    carouselProps,
    ...rest
  }) => {
    const reduxItemCount = useSelector(getItemCount);
    const itemCount =
      propItemCount !== undefined ? propItemCount : reduxItemCount;

    let upSellCarousel = null;
    if (
      carouselProps !== null &&
      itemCount >= MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL
    ) {
      upSellCarousel = <UpSellCarousel {...carouselProps} />;
    }

    return (
      <WrappedComponent
        {...{
          ...rest,
          itemCount,
          upSellCarousel,
        }}
      />
    );
  };

  WithUpSellCarousel.propTypes = {
    itemCount: PropTypes.number,
    carouselProps: PropTypes.object,
  };

  return WithUpSellCarousel;
};

export default withUpSellCarousel;
